import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminProfileRoute extends Route {
  // Services
  @service permission;

  // Hooks
  model() {
    return this.permission.user;
  }
}
